module.exports = __webpack_public_path__ + "static/media/tracker-rating.186a98d5.svg";